import {
  DELETE_SUBSCRIBER,
  DELETE_SUBSCRIBER_FAILURE,
  DELETE_SUBSCRIBER_SUCCESS,
  GET_SUBSCRIBERS,
  GET_SUBSCRIBERS_FAILURE,
  GET_SUBSCRIBERS_SUCCESS,
} from "./actionTypes";

const initialState = {
  subscribers: [],
  isLoggedIn: null,
  loading: false,
  error: "",
};

const subscribers = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIBERS:
      return { ...state, loading: true, error: "" };

    case GET_SUBSCRIBERS_SUCCESS:
      return { ...state, subscribers: action.payload, loading: false };

    case GET_SUBSCRIBERS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    case DELETE_SUBSCRIBER:
      return { ...state, loading: true, error: "" };

    case DELETE_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        loading: false,
        subscribers: state.subscribers.filter(
          (subscriber) => subscriber._id !== action.payload
        ),
      };

    case DELETE_SUBSCRIBER_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default subscribers;
